import styled from 'styled-components';

import backgroundImg from '../assets/Foto-Quadra-Boa.jpg';
import logo from '../assets/logo.png';
import tennisImage from '../assets/tenis_dash.jpg';
import encarte2026 from '../assets/encarte_2026.jpg';

export const Colors = {
  'transparent_black': '#00000050',
  'transparent_sand': '#ffd43980',
  'transparent_white': '#DDDDDDD0',
  'hover_blue': '#0056b3',
  'button_blue': '#254671',
  'menu_blue': '#1876BB',
  'card_blue': '#007bff',
  'error_red': '#ff6347',
  'zap_green': '#25d366',
  'insta_pink': '#E4405F',
  'divider_gray': '#CCC',
};

export const Imgs = {
  'logo': logo,
  'tennis': tennisImage,
  'background': backgroundImg,
  'encarte': encarte2026,
};

export const ContainerHome = styled.div `
  display: flex;
  flex-direction: column;
  background-image: url(${Imgs.background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  color: white;
  overflow-x: hidden;
`;

export const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; 
  background: url(${Imgs.background}) no-repeat center center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const Overlay = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${Colors.transparent_black};
  z-index: 1;
  border-radius: 15px;
`;

export const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  text-align: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Logo = styled.img `
  width: 191px;
  margin-left: 30px;

  @media (max-width: 768px) {
    width: 186px;
    margin-bottom: 10px;
  }
`;

export const SocialIcons = styled.div `
  display: flex;
  gap: 20px;
  margin-right: 60px;

  @media (max-width: 768px) {
    margin-right: 0;
  }
`;

export const SocialIcon = styled.a `
  color: black;
  font-size: 24px;
  text-decoration: none;

  &:hover {
    color: ${Colors.zap_green};
  }

  &:nth-child(2):hover {
    color: ${Colors.insta_pink};
  }
`;

export const Content = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin: 25px;
  flex: 1;

  @media (max-width: 768px) {
    align-items: center;
    margin-right: 0;
  }
`;

export const TextContainer = styled.div `
  position: relative;
  padding: 20px;
  width: 35%;
  color: white;
  border-radius: 15px;
  margin-top: 200px;

  @media (max-width: 768px) {
    width: 80%;
    margin-top: 100px;
  }
`;

export const Text = styled.p `
  font-size: 18px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
    text-align: center;
    justify-content: center;
  }
`;

export const LoginButton = styled.button `
  background-color: ${Colors.transparent_sand};
  color: black;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;

  &:hover {
    background-color: ${Colors.hover_blue};
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 16px;
    width: 117px;
  }
`;

export const LeftSide = styled.div `
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

export const ButtonsWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 25px;
    align-items: center;
  }
`;

export const InputContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2%;
  width: 33%;
  background-color: ${Colors.transparent_black};
  border-radius: 3%;
  
  @media (max-width: 768px) {
    width: 80%;
  }
`;

export const InputWrapper = styled.div `
  width: 100%;
  max-width: 400px;
  margin: 20px 0;
`;

export const Label = styled.label `
  color: white;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
`;

export const Input = styled.input `
  width: 100%;
  padding: 10px;
  border: none;
  background: transparent;
  color: white;
  font-size: 16px;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
`;

export const Underline = styled.div `
  width: 100%;
  height: 1px;
  background-color: white;
  margin-top: 5px;
`;

export const PasswordWrapper = styled.div `
  position: relative;
  display: flex;
  align-items: center;
`;

export const EyeIcon = styled.div `
  position: absolute;
  right: 10;
  cursor: pointer;
  color: black;
`;

export const Button = styled.button `
  width: 100%;
  max-width: 400px;
  padding: 15px;
  margin: 20px 0;
  border: none;
  border-radius: 4px;
  background-color: white;
  color: ${Colors.button_blue};
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.button_blue};
    color: white;
  }
`;

export const Link = styled.a `
  color: ${Colors.transparent_white};
  text-decoration: none;
  margin: 10px 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const Divider = styled.div `
  color: white;
  margin: 20px 0;
  display: flex;
  align-items: center;
  z-index: 2;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid white;
  }

  &::before {
    margin-right: 10px;
  }

  &::after {
    margin-left: 10px;
  }
`;

export const Message = styled.p `
  color: ${Colors.button_blue};
  background-color: ${({ type }) => (type === 'error' ? Colors.error_red : Colors.transparent_white)};
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  margin-top: 10px;
`;

export const RegisterMessage = styled.h1 `
  color: white;
  margin: 50px 0;
  font-family: "Bellota", system-ui;
  letter-spacing: 0.5px;
  display: flex;
  justify-content: center;
`;

export const Logomarca = styled.img `
  max-width: 100%; 
  max-height: 100px; 
  width: auto; 
  height: auto; 
  object-fit: contain;
`;

export const SignUpContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url(${Imgs.background}) no-repeat center center;
  background-size: cover;
  min-height: 100vh; 
  padding: 20px 0; 
  box-sizing: border-box;
`;

export const Form = styled.form `
  width: 100%;
  max-width: 500px; 
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ProfileForm = styled.form `
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
`;

export const InputWrappers = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const ButtonPassword = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  background: #fff;
  width: 24%;
  justify-content: center;
  margin-top: 5px;
  border-radius: 22px;
  font-family: Bellota;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.button_blue};
    color: white;
  }
`;

export const ButtonRegister = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  background: #fff;
  width: 80%;
  justify-content: center;
  margin-top: 5px;
  border-radius: 22px;
  font-family: Bellota;
  cursor: pointer;
  padding: 7px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background-color: ${({ disabled }) => (disabled ? 'gray' : Colors.button_blue)};
  color: ${({ disabled }) => (disabled ? 'black' : 'white')};
`;

export const CheckboxContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledButton = styled.button `
  width: 100%;
  max-width: 400px;
  padding: 15px;
  margin: 20px 0;
  border: none;
  border-radius: 4px;
  background-color: #fff;
  color: ${Colors.button_blue};
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.button_blue};
    color: white;
  }
`;

export const LogoWrapper = styled.div `
  width: ${props => props.width || '100px'}; 
  height: ${props => props.height || 'auto'}; 
`;

export const LogoImage = styled.img `
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

export const DividerContainer = styled.div `
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
  width: 80%;
  max-width: 400px;
`;

export const Line = styled.div `
  flex: 1;
  height: 1px;
  background-color: ${Colors.divider_gray}; 
`;

export const DividerText = styled.span `
  margin: 0 10px;
  color: ${Colors.divider_gray};
  font-weight: bold;
`;

export const DashboardContainer = styled.div `
  display: flex;
  position: relative;
  min-height: 100vh; 
  width: 100vw;
  box-sizing: border-box;
  padding-top: 80px; 
  padding-left: 124px; 

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${Imgs.background});
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    background-repeat: no-repeat;
    z-index: -1;
  }

  @media (max-width: 768px) {
    padding-left: 0; /* Remove o espaço da sidebar no mobile */
    padding-top: 120px; /* Ajuste para o mobile se o header tiver altura diferente */
  }
`;

export const MainContent = styled.div `
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const DashboardContent = styled.div `
  padding: 20px 0;
  flex: 1; /* Permite que o conteúdo se expanda para preencher o espaço */
  box-sizing: border-box; /* Inclui o padding e bordas na largura total */

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const CenteredContent = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 70px); /* Ajuste conforme a altura do header */
  padding: 20px;

   &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${Imgs.background});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: -1; 
  }
`;

export const MenuContainer = styled.div `
  width: 124px;
  height: 100vh;
  background: ${Colors.transparent_black};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999; 
  transition: transform 0.3s ease; 

  @media (max-width: 768px) {
    transform: translateX(-100%); 
    &.open {
      transform: translateX(0); 
    }
  }
`;

export const LogoContainer = styled.div `
  width: 100px;
  height: 40px;
  z-index: 9999;
`;

export const MenuLogo = styled.img `
  width: 100%;
  height: auto;
  display: block;
`;

export const MenuWrapper = styled.div `
  margin-top: 200px;
`;

export const MenuItem = styled.div `
  width: 100%;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.2); 
    color: ${Colors.menu_blue}};
  }

  a {
    text-decoration: none;
    color: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  span {
    font-size: 12px;
    margin-top: 5px;
  }

  svg {
    margin-bottom: 5px;
  }
`;

export const HeaderContainer = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px; 
  display: flex;
  align-items: center;
  justify-content: space-between; 
  background: ${Colors.transparent_black};
  z-index: 1000; 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px 0;
  }
`;

export const HeaderLogoImage = styled.img `
  height: 50px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
    width: 143px;
  }
`;

export const TextAndImageContainer = styled.div `
  display: flex;
  align-items: center;
  margin: 0 auto;
  gap: 25px;

  @media (max-width: 768px) {
    align-items: center;
    flex-direction: column;
    gap: 0;
  }
`;

export const GreetingContainer = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    margin-bottom: 0;
    gap: 10px;
  }
`;

export const Greeting = styled.h1 `
  font-size: 24px;
  color: #fff;
  margin: 0 10px 0 0;
  font-weight: 500;
  font-family: "Bellota", system-ui;

  @media (max-width: 768px) {
    text-align: center;
    margin: 0;
    font-size: 20px;
  }
`;

export const ProfileImage = styled.img `
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
`;

export const MenuButton = styled.button `
  position: fixed; 
  top: 15px;
  left: 20px;
  background: none;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 30px;
  z-index: 2000;
  display: flex;
  align-items: center;
  display: none;

  @media (max-width: 768px) {
    display: block;
    color: #FFF;
    display: visible;
  }
`;

export const Nav = styled.nav `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  color: #000;
  width: 80%; /* Reduzindo a largura do modal */
  max-width: 400px; /* Limite de largura para dispositivos maiores */
  max-height: 80vh; /* Altura máxima */
  overflow-y: auto; /* Permite rolagem se necessário */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1500;
  display: ${props => (props.$isOpen ? 'flex' : 'none')}; /* Exibe flex quando o menu está aberto */
  flex-direction: column;
  padding: 20px;
  border-radius: 15px; /* Bordas arredondadas */
`;

export const MenuList = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin: 20px 0;
    font-size: 18px;
  }
`;

export const HeaderOverlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: ${props => (props.$isOpen ? 'block' : 'none')}; /* Mostra o overlay quando o menu está aberto */
`;

export const PageContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 20px;
  background-color: ${Colors.transparent_white};
  border-radius: 5%;
  position: relative;
  margin-left: 125px; 
  margin-top: 125px; 

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1; 
  }

  @media (max-width: 768px) {
    margin-top: 120px;
    padding: 10px;
    margin-left: 0; /* Remove o deslocamento para a sidebar em telas menores */
  }
`;

export const SectionGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Duas colunas */
  gap: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr; /* Ajusta para uma coluna em telas menores que 1024px */
  }

  @media (max-width: 768px) {
    gap: 15px;
  }
`;

export const Section = styled.section `
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 10px 0;
`;

export const SectionTitle = styled.h3 `
  margin-bottom: 20px;
  font-size: 1.5rem;
  color: #333;
  font-family: Bellota;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    margin-bottom: 15px;
  }
`;

export const CardGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Duas colunas para os cards */
  gap: 20px;
  max-height: 400px;  
  overflow-y: auto;   
  padding-top: 5px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr; /* Ajusta para uma coluna em telas menores que 1024px */
  }

  @media (max-width: 768px) {
    gap: 15px;
    max-height: none; /* Remove o limite de altura em telas menores */
  }
`;

export const Card = styled.div `
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 2%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

export const CardContent = styled.div `
  margin-bottom: 15px;
`;

export const CardText = styled.p `
  margin: 5px 0;
  color: #555;
  font-size: 0.9rem;

  strong {
    color: #333;
  }

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

export const CardButton = styled.button `
  padding: 10px 15px;
  background-color: ${Colors.card_blue};
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.hover_blue};
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 0.85rem;
  }
`;

export const InputGroup = styled.div `
  flex: 1 1 48%;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
`;

export const ProfileLabel = styled.label `
  color: ${Colors.menu_blue};
  font-weight: bold;
  margin-bottom: 5px;
`;

export const ProfileContainer = styled.div `
  max-width: 1000px;
  padding: 20px;
  background: ${Colors.transparent_white};
  border-radius: 5%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
  display: flex;
  gap: 20px;
  margin-top: 120px;
  flex-wrap: wrap;
  flex-direction: column;
  position: relative;
  margin: 125px; 
  
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1; 
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    margin: 20px 0;
  }

  @media (max-width: 768px) {
    padding: 20px;
    flex-direction: column;
    margin: 120px 0;
  }
`;

export const ProfileInput = styled.input `
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;

  &:focus {
    outline: 2px solid ${Colors.menu_blue};
  }
`;

export const CouponsSection = styled.div `
  margin-top: 20px;
  width: 100%;
  text-align: center;
`;

export const CouponItem = styled.li `
  background: #E8F5E9;
  padding: 10px;
  border: 1px solid ${Colors.menu_blue} ;
  border-radius: 5px;
  flex: 1 1 45%;
  text-align: center;
  font-weight: bold;

  @media (max-width: 768px) {
    flex: 1 1 100%;
  }
`;

export const CouponList = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px;
  justify-content: flex-start;

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    flex-direction: column; /* Coloca os cards um embaixo do outro */
    gap: 15px; /* Menor espaçamento entre os cards */
    padding: 0;
    max-height: none; /* Remove a limitação de altura no mobile */
    overflow-y: auto; /* Garante o scroll vertical */
    overflow-x: hidden; /* Garante que o scroll horizontal não seja ativado */
  }

  /* Desktop - Contêiner com scroll vertical */
  @media (min-width: 769px) {
    max-height: 500px; /* Defina uma altura máxima (ajustável) */
    overflow-y: auto; /* Scroll vertical caso o conteúdo ultrapasse a altura */
    overflow-x: hidden; /* Garante que o scroll horizontal não seja ativado */
  }
`;

export const CouponCard = styled.div `
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  margin: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: left;
  width: calc(50% - 20px); /* Ajusta para 50% da largura, com o gap de 20px */
  box-sizing: border-box;

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    width: 100%; /* Faz com que os cards ocupem 100% da largura em dispositivos móveis */
    margin: 0;
  }
`;

export const Avatar = styled.img `
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
  }
`;

export const AvatarWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonGroup = styled.div `
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const ProfileButton = styled.button `
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #0056b3;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }

  &.cancel {
    background-color: red;

    &:hover {
      background-color: darkred;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 5px 0;
  }
`;

export const ScheduleContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%; /* Isso garante que o container tenha altura suficiente */
  overflow-y: auto;
  box-sizing: border-box;

   &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1; 
  }

  @media (min-width: 768px) {
    flex-direction: column;
    height: 100%; /* Adicionar isso para garantir rolagem */
    overflow-y: auto;
    padding-top: 0;
  }
`;

export const TopSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    width: 80%;
    gap: 30px;
    margin-top: 9%; 
    margin-left: 8%;
  }
`;

export const BottomSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    width: 80%;
    gap: 30px;
    margin-top: 20px; 
    margin-left: 8%;
  }
`;

export const LeftSection2 = styled.div `
  flex: 1;
  background-color: ${Colors.transparent_white};
  border-radius: 5%;
  padding: 5px 5px 10px 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 767px) { 
    width: 100%; 
    height: auto; 
    margin-top: 20px; 
    box-sizing: border-box; 

    /* Esconde itens a partir do quarto apenas em mobile */
    & > *:nth-child(n+4) {
      display: none; 
    }
  }

  @media (min-width: 768px) {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const LeftSection1 = styled.div `
  flex: 1;
  background-color: ${Colors.transparent_white};
  border-radius: 5%;
  padding: 5px 5px 10px 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 767px) { 
    width: 100%; 
    height: auto; 
    margin-top: 120px; 
    box-sizing: border-box; 

    /* Esconde itens a partir do quarto apenas em mobile */
    & > *:nth-child(n+4) {
      display: none; 
    }
  }

  @media (min-width: 768px) {
    height: auto;
  }
`;

export const RightSection = styled.div `
  flex: 1;
  max-width: 100%;
  background-color: ${Colors.transparent_white};
  border-radius: 5%;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media (min-width: 768px) {
    width: 100%; /* Garante que ocupe o espaço disponível */
  }
`;

export const CalendarHeader = styled.h2 `
  width: 100%; 
  justify-content: center; 
  color: #000; 
  font-family: "Bellota"; 
  font-size: 17px; 
  display: flex; 
  margin: 0 0 20px 0;
  font-weight: 700;
  text-align: center;  

  @media (min-width: 768px) {
    margin: 0;
    margin-bottom: 20px;
    color: #333;
    font-size: 22px;  
  }  
`;

export const DayHeader = styled.div `
  display: grid;
  grid-template-columns: repeat(7, 1fr); 
  gap: 10px; 
  justify-items: center;
  margin-bottom: 15px;
  font-size: 13px;
  text-align: center;
  cursor: default;
  opacity: 1;

  @media (min-width: 1200px) {
    font-size: 16px;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    gap: 15px; 
    font-size: 15px;
  }

  @media (max-width: 991px) {
    gap: 8px; 
    font-size: 12px;
  }
`;

export const Day = styled.div `
  background-color: ${({ $available, $occupied, selected }) => 
    $occupied ? 'red' : selected ? 'green' : $available ? 'lightblue' : 'white'};
  border-radius: 3px;
  cursor: ${props => props.$available ? 'pointer' : 'default'};
  opacity: ${props => props.selected ? '0.6' : '1'};
  border: ${props => props.selected ? '2px solid ' + Colors.menu_blue : 'none'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;

  @media (min-width: 1200px) {
    width: 45px;
    height: 35px;
    font-size: 15px;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    width: 42px;
    height: 32px;
    font-size: 14px;
  }

  @media (max-width: 991px) {
    width: 38px;
    height: 30px;
    font-size: 13px;
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 34px;  
    font-size: 12px;
  }
`;

export const CalendarGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(7, 1fr); /* Mesmo número de colunas que o DayHeader */
  gap: 10px;
  cursor: pointer;

  @media (max-width: 991px) {
    gap: 8px;
    width: 97%;
  }

  @media (max-width: 767px) {
    gap: 5px; /* Reduz o espaçamento no mobile */
    width: 97%;
  }
`;

export const AppointmentContainer = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

export const AppointmentList = styled.div `
  max-height: 300px;  
  overflow-y: auto;
  box-sizing: border-box; 
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    max-height: 200px;  
  }
`;

export const AppointmentItem = styled.div `
  padding: 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 35%;
  margin: 1% 2%;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: flex-start;
`;

export const AppointmentTitle = styled.h2 `
  width: 100%; 
  justify-content: center; 
  color: #000; 
  font-family: "Bellota"; 
  font-size: 22px;
  display: flex;
  margin: 20px 0 20px 0;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 27px;
    margin-top: 20px; 
  } 
`;

export const ImageCard = styled.div `
  position: relative;
  width: 100%;

  img {
    width: 100%;
    height: 400px;
    object-fit: contain;
    border-radius: 5px;
    background-color: '#DDD'
  }

  @media (max-width: 768px) {
    img {
      height: 300px;
    }
  }

  /*
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 5px;
      z-index: 1;
    }

    &::after {
      content: "A única maneira de alcançar a perfeição é a prática constante";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%); /* Centraliza o texto */
      color: white;
      font-size: 1.5rem;
      font-family: "Bellota"; 
      font-weight: bold;
      text-align: center;
      padding: 0 10px;
      width: 100%;
      z-index: 2; /* Para garantir que o texto fique acima do overlay */

      @media (max-width: 768px) {
        font-size: 1rem;
      }

      @media (max-width: 480px) {
        font-size: 1rem; 
      }
    }
  */
`;

export const CalendarTitle = styled.h2 `
  text-align: center;
  font-size: 27px;
  margin-bottom: 20px;
  color: #333;
  font-family: "Bellota"; 

  @media (max-width: 1024px) {
    font-size: 22px;
    margin-bottom: 15px;
  }
  
  @media (max-width: 768px) {
    font-size: 21px;
    margin-bottom: 10px;
  }
`;

export const SelectedDates = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px;

  @media (min-width: 768px) {
    margin-top: 10px;
    font-size: 18px;
    gap: 10px;
  }
`;

export const TimeSelect = styled.select `
  margin-top: 5px;
  width: 200px;
  height: 25px;

  @media (min-width: 768px) {
    height: 33px;
  }
`;

export const StyledInput = styled.input `
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
  height: 37px;

  @media (max-width: 768px) {
    height: 20px;
    padding: 10px;
    font-size: 11px;
  } 
`;

export const StyledPaymentButton = styled.button `
  background-color: #1B76BB;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  height: 35px;
  font-size: 14px;
  width: 117px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #fff;
    color: #1B76BB;
    border: 1px solid #1B76BB;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    height: 24px;
    font-size: 10px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  } 
`;

export const TicketStyle = styled.div `
  display: flex; 
  align-items: center;
  gap: 7px;

  @media (max-width: 768px) {
    max-width: 48%; 
    align-items: center;
  }
`;

export const OptionLabel = styled.label `
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const OptionWrapper = styled.div `
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;

  @media (max-width: 768px) {
    flex-direction: column;
    font-size: 16px;
    padding: 8px;
  }
`;

export const OptionInput = styled.input `
  margin-right: 10px;
  cursor: pointer;
`;

export const ButtonPayment = styled.button `
  background-color: #1B76BB;
  color: #fff;
  padding: 10px;
  width: 150px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 35px;

  &:hover {
    background-color: #fff;
    color: #1B76BB;
    border: 1px solid #1B76BB;
    cursor: pointer;
  }
`;

export const PaymentMessage = styled.p `
  color: ${(props) => (props.isValid ? 'green' : 'red')};
  margin-top: 10px;
`;

export const AddGuestContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AddGuestLabel = styled.label `
  font-family: Bellota;
  font-weight: 600;
  color: rgb(27, 118, 187);
`;

export const AddGuestButton = styled.button `
  padding: 8px 16px;
  background-color: #1B76BB;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: white;
    color: #1B76BB;
    border: solid 1px #1B76BB;
  }

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const SearchContainer = styled.div `
  position: relative;
`;

export const SearchInput = styled.input `
  padding: 8px;
  width: 200px;
  border: 1px solid #ccc;
  border-radius: 5px;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const DropdownList = styled.ul `
  position: absolute;
  top: 35px;
  left: 0;
  width: 100%;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const DropdownItem = styled.li `
  padding: 8px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f1f1f1;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const NoResults = styled.li `
  padding: 8px;
  color: #888;
  font-size: 14px;
  list-style: none;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const SelectedGuestsContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const GuestItem = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const RemoveButton = styled.button `
  background-color: #1B76BB;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  padding: 3px 8px;

  &:hover {
    background-color: #ff1a1a;
  }
`;

export const ErrorMessage = styled.div `
  color: red;
  font-size: 14px;
`;

export const ModalWrapper = styled.div `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  width: 600px;
  max-width: 90%;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  text-align: center;

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    width: 90%;
    padding: 15px;
  }

  @media (max-width: 480px) {
    width: 95%;
    padding: 10px;
  }
`;

export const ModalContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CloseButton = styled.button `
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;

  &:hover {
    color: #000;
  }

  /* Ajuste do tamanho do botão para telas menores */
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const QRCodeImage = styled.img `
  width: 200px;
  height: 200px;

  /* Ajuste da imagem do QRCode para telas menores */
  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
  }

  @media (max-width: 480px) {
    width: 120px;
    height: 120px;
  }
`;

export const TransactionDetails = styled.p `
  font-size: 16px;
  color: #333;
  margin: 10px 0;

  /* Aumenta a legibilidade em telas menores */
  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

export const ButtonPaymentModal = styled.button `
  background-color: #007bff;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background-color: #0056b3;
  }

  /* Ajuste de padding e tamanho da fonte para dispositivos móveis */
  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;

export const ConfirmationOverlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;

  div {
    background: white;
    padding: 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    max-width: 400px;
    text-align: center;
  }

  @media (max-width: 768px) {
    div {
      max-width: 90%; /* Ajusta a largura para o mobile */
      font-size: 14px; /* Reduz o tamanho do texto no mobile */
    }
  }
`;

export const ModalOverlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalCouponContent = styled.div `
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  width: 400px;
`;

export const ModalTitle = styled.h2 `
  margin: 0;
  font-size: 20px;
  color: #333;
`;

export const CouponCloseButton = styled.button `
  margin-top: 15px;
  padding: 10px 20px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  
  &:hover {
    background: #218838;
  }
`;

export const AdminContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #DDDDDDD0; /* Fundo branco com transparência */
  border-radius: 35px; /* Bordas arredondadas para um design moderno */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Sombra suave para destaque */
  min-height: calc(100vh - 90px);
  margin-top: 90px;
  width: calc(100% - 124px); 
  margin-left: 124px; /* Compensa a largura da Sidebar */

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    width: 100%;
    margin: 120px 0 0 0;
    padding: 10px; /* Reduz padding em telas menores */
  }
`;

export const AdminHeader = styled.h1 `
  font-size: 28px;
  color: #0156B3;
  margin-bottom: 20px;
  font-family: Bellota;

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    font-size: 22px; /* Reduz tamanho da fonte em telas menores */
    text-align: center; /* Centraliza o texto */
  }
`;

export const TabContainer = styled.div `
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;

  /* Esconde as tabs no mobile */
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Tab = styled.button `
  padding: 10px 20px;
  font-size: 16px;
  color: ${(props) => (props.active ? "#fff" : "#333")};
  background-color: ${(props) => (props.active ? "#007bff" : "#e9ecef")};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: ${(props) => (props.active ? "#0056b3" : "#d6d8db")};
  }

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    padding: 8px 15px;
    font-size: 14px;
  }
`;

export const MobileSelect = styled.select `
  display: none; /* Esconde no desktop */
  width: 100%;
  max-width: 300px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;

  @media (max-width: 768px) {
    display: block; /* Mostra no mobile */
  }
`;

export const AdminContent = styled.div `
  width: 100%;
  max-width: 800px;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    padding: 15px;
    max-width: 90%;
    margin-top: 30px;
  }
`;

export const AdminContentContainer = styled.div `
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const AdminContentTitle = styled.h2 `
  margin-bottom: 16px;
  font-size: 1.5rem;
  text-align: center;
  color: #254671;
  font-family: Bellota;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    text-align: center;
  }
`;

export const AdminListTitle = styled.h3 `
  margin-bottom: 0;
  font-size: 1.5rem;
  text-align: center;
  color: #254671;
  font-family: Bellota;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    text-align: center;
  }
`;

export const GrantButton = styled.button `
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const AdminsList = styled.div `
  h3 {
    margin-bottom: 12px;
    color: #555;
    font-size: 1.25rem;

    @media (max-width: 768px) {
      font-size: 1rem;
      text-align: center;
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }
`;

export const AdminItem = styled.li `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const RevokeButton = styled.button `
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  background-color: #dc3545;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #a71d2a;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;

export const ScrollContainer = styled.div `
  max-height: 220px; /* ajusta conforme quiser */
  overflow-y: auto;
  margin-bottom: 20px;
  padding-right: 8px;

  /* opcional: scrollbar estilizada */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #999;
  }
`;

export const AdminContentForm = styled.form `
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const FormGroup = styled.div `
  display: flex;
  flex-direction: column;
`;

export const AdminContentLabel = styled.label `
  font-size: 14px;
  color: #555;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const AdminContentInput = styled.input `
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;

  &:focus {
    border-color: #007bff;
    outline: none;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px;
  }
`;

export const DropdownContainer = styled.div `
  position: relative;
`;

export const AdminContentSearchInput = styled.input `
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px;
  }
`;

export const AdminContentDropdownList = styled.ul `
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

export const AdminContentDropdownItem = styled.li `
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #333;

  &:hover {
    background: #f1f1f1;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const AdminContentNoResults = styled.li `
  padding: 8px 12px;
  font-size: 14px;
  color: #999;

  @media (max-width: 768px) {
    font-size: 13px;
    text-align: center;
  }
`;

export const AdminContentButton = styled.button `
  z-index: 50;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 8px 12px;
  }
`;

export const AdminContentCouponList = styled.div `
  h3 {
    margin-bottom: 12px;
    color: #555;

    @media (max-width: 768px) {
      font-size: 16px;
      text-align: center;
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }

  p {
    color: #888;

    @media (max-width: 768px) {
      text-align: center;
    }
  }
`;

export const AdminContentCouponItem = styled.li `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const CouponDetails = styled.span `
  font-size: 14px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const DeleteButton = styled.button `
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  background-color: #dc3545;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #a71d2a;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px 8px;
  }
`;

export const ErrorContainer = styled.div `
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 15px;
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 5px;
  font-size: 14px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ErrorText = styled.p `
  margin: 0;
  font-weight: bold;
`;

export const AdminContentSearchContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const DateInput = styled.input `
  flex: 1;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:focus {
    border-color: #007bff;
    outline: none;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px;
  }
`;

export const SearchButton = styled.button `
  padding: 8px 16px;
  font-size: 14px;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 8px 12px;
  }
`;

export const BookingDetailsContainer = styled.div `
  padding: 16px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const Detail = styled.p `
  font-size: 14px;
  color: #555;

  strong {
    color: #333;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const GuestList = styled.ul `
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
`;

export const BookingItem = styled.div `
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 4px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const BookingListContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const BookingListItem = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  background-color: white;

  &:hover {
    background-color: #f1f1f1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    padding: 12px;
  }
`;

export const Subtitle = styled.h3 `
  font-size: 16px;
  color: #555;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const CancelButton = styled.button `
  background-color: #ff4d4d;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ff3333;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const BackButton = styled.button `
  background-color: ${Colors.card_blue};
  color: #fff;
  margin: 0 2%;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
  transition: background-color 0.3s ease;
`;

export const RefundOptionsContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
  padding: 10px;
  background-color: #f7f7f7;
  border-radius: 8px;
  border: 1px solid #ddd;
`;

export const RefundOption = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;

  input[type="radio"] {
    margin: 0;
    cursor: pointer;
  }

  label {
    font-size: 16px;
    cursor: pointer;
  }

  label:hover {
    text-decoration: underline;
  }
`;

export const ConfirmCancel = styled.button `
  background-color: #e04e4e;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;

  &:hover {
    background-color: #c43f3f;
  }

  &:disabled {
    background-color: #d6d6d6; // Cor de fundo para quando o botão estiver desabilitado
    cursor: not-allowed; // Cursor indicando que não é possível interagir
    opacity: 0.6; // Diminui a opacidade para dar uma indicação visual
  }

  &.disabled {
    background-color: #d6d6d6; // Mesma cor de fundo quando desabilitado
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const CancelDateForm = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const CancelDateLabel = styled.label `
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #555;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const CancelDateInput = styled.input `
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 4px;

  &:focus {
    border-color: #007bff;
    outline: none;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px;
  }
`;

export const AddButton = styled.button `
  padding: 10px 16px;
  font-size: 14px;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 8px 12px;
  }
`;

export const BlockedList = styled.div `
  margin-top: 16px;

  @media (max-width: 768px) {
    margin-top: 12px;
  }
`;

export const NoBlocks = styled.p `
  text-align: center;
  color: #888;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const BlockedItem = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;

  span {
    font-size: 14px;
    color: #333;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    span {
      font-size: 13px;
    }
  }
`;

export const SubmitButton = styled.button `
  margin-top: 16px;
  padding: 8px 16px;
  font-size: 14px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 8px 12px;
  }
`;

export const CheckboxGroup = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  gap: 10px;

  @media (max-width: 768px) {
    gap: 8px;
    margin-bottom: 16px;
  }
`;

export const CheckboxLabel = styled.label `
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  color: #333;
  cursor: pointer;

  input[type="radio"] {
    accent-color: #007bff;
    width: 18px;
    height: 18px;
  }

  &:hover {
    color: #0056b3;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    gap: 8px;

    input[type="radio"] {
      width: 16px;
      height: 16px;
    }
  }
`;

export const Select = styled.select `
  width: 100%;
  padding: 8px;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: gray;
  margin-top: 5px;
  
  &:focus {
    border-color: #007bff;
    outline: none;
  }
`;

export const DateList = styled.div `
  margin-top: 20px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`;

export const DateItem = styled.div `
  margin: 5px;
  padding: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  
  strong {
    color: #333;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const UserDetailsContainer = styled.div `
  margin-top: 16px;
  padding: 16px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;

  @media (max-width: 768px) {
    margin-top: 12px;
    padding: 12px;
  }
`;

export const UserDetail = styled.p `
  font-size: 14px;
  color: #555;

  strong {
    color: #333;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const UserList = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;

  @media (max-width: 768px) {
    max-height: 150px; /* Reduz a altura da lista para dispositivos menores */
  }

  /* Estilização da barra de rolagem */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #aaa;
  }
`;

export const UserItem = styled.li `
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid #f1f1f1;

  &:hover {
    background-color: #f1f1f1;
  }

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px;
  }
`;

export const AdminContentSearchInputUser = styled.input `
  width: 100%;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:focus {
    border-color: #007bff;
    outline: none;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px;
  }
`;

export const AdminUserHistoryContent = styled.div `
  display: flex;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const AdminUserHistoryList = styled.div `
  flex: 1;

  @media (max-width: 768px) {
    flex: none;
  }
`;

export const AdminUserHistoryItem = styled.div `
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  background-color: ${({ isSelected }) => (isSelected ? "#007bff" : "#fff")};
  color: ${({ isSelected }) => (isSelected ? "#fff" : "#333")};
  margin-bottom: 4px;
  font-size: 14px;

  &:hover {
    background-color: #007bff;
    color: #fff;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 6px;
  }
`;

export const ScrollableList = styled.div `
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  background-color: #fff;

  @media (max-width: 768px) {
    max-height: 150px; /* Reduz altura em telas menores */
  }

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }
`;

export const List = styled.ul `
  list-style: none;
  padding: 0;
  margin: 0;

  @media (max-width: 768px) {
    margin-top: 12px;
  }
`;

export const ListItem = styled.li `
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 8px;
  background-color: white;

  @media (max-width: 768px) {
    margin-bottom: 6px;
  }
`;

export const ListHeader = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background-color: #f1f1f1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 12px;
  }
`;

export const ListRole = styled.span `
  font-size: 14px;
  color: #555;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const ListCount = styled.span `
  font-size: 14px;
  color: #007bff;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const ListDetails = styled.div `
  padding: 8px 16px;
  background-color: #f9f9f9;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 8px 12px;
  }
`;

export const Tabs = styled.div `
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    border-bottom: none;
  }
`;

export const AdminTab = styled.button `
  padding: 8px 16px;
  border: none;
  border-bottom: ${({ isActive }) =>
    isActive ? "3px solid #007bff" : "3px solid transparent"};
  background: none;
  color: ${({ isActive }) => (isActive ? "#007bff" : "#555")};
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #007bff;
  }

  @media (max-width: 768px) {
    padding: 10px;
    text-align: left;
    border-left: ${({ isActive }) =>
      isActive ? "3px solid #007bff" : "3px solid transparent"};
    border-bottom: none;
  }
`;

export const ActionButtons = styled.div `
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

export const ActionButton = styled.button `
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &.approve {
    background-color: #28a745;
    color: white;

    &:hover {
      background-color: #218838;
    }
  }

  &.deny {
    background-color: #dc3545;
    color: white;

    &:hover {
      background-color: #a71d2a;
    }
  }
`;
